<template>
  <v-tooltip
    v-bind="tooltipProps"
    :top="position === 'top'"
    :bottom="position === 'bottom'"
    :left="position === 'left'"
    :right="position === 'right'"
  >
    <template #activator="{ on, attrs }">
      <span
        class="info-tooltip__activator d-flex align-center"
        v-bind="attrs"
        v-on="on"
      >
        <slot name="activator">
          <v-icon
            color="primaryTeal"
            size="28"
          >
            mdi-help-circle
          </v-icon>
        </slot>
      </span>
    </template>

    <span>{{ message }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'InfoTooltip',
    props: {
      message: {
        type: String,
        required: true,
      },
      position: {
        type: String,
        default: 'top',
        validator: value =>
          ['top', 'bottom', 'left', 'right'].includes(value),
      },
      tooltipProps: {
        type: Object,
        default: () => ({}),
      },
    },
  }
</script>

<style scoped>
.info-tooltip__activator {
  cursor: pointer;
}
</style>
